type Map = {
  [props: string]: string;
};

export const colorsMap: Map = {
  // 'big-arrow-down': '#9B9B9B',
  // 'big-arrow-up': '#9B9B9B',
  'bubble-check': '#004DF5',
  'cancel-circle': '#2B2F3B',
  'green-check': 'supplementary.2',
  'green-plus-circle': '#12DE9A',
  'check-circle': '#12b76a',
  'disabled-check-light': '#D8D8D8',
  minus: '#C4C4C4',
  'minus-big': '#ED0164',
  more: '#05164C',
  'more-dots': '#05164C',
  pencil: '#FFFFFF',
  plusCircle: '#FFFFFF',
  'red-cancel-circle': '#F46C6C',
  remove: '#ED0164',
  'small-alert': '#FFA617',

  'speed-meter': '#007BFF',
  spinner: '#D8D8D8',
  texting: '#2B2F3B',
};
